/**
 * @generated SignedSource<<ebb19cd6469fbbd54861e4214d1fc60c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksFeedViewAuthorPaginationQuery$variables = {
  after?: string | null | undefined;
  applicationIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  count?: number | null | undefined;
  excludeEntityIds?: ReadonlyArray<string | null | undefined> | null | undefined;
  id: string;
};
export type hooksFeedViewAuthorPaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"hooksFeedViewAuthorFragment">;
  } | null | undefined;
};
export type hooksFeedViewAuthorPaginationQuery = {
  response: hooksFeedViewAuthorPaginationQuery$data;
  variables: hooksFeedViewAuthorPaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "after"
  },
  {
    "defaultValue": ([]/*: any*/),
    "kind": "LocalArgument",
    "name": "applicationIds"
  },
  {
    "defaultValue": 20,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": ([]/*: any*/),
    "kind": "LocalArgument",
    "name": "excludeEntityIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v3 = {
  "kind": "Variable",
  "name": "applicationIds",
  "variableName": "applicationIds"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = [
  (v2/*: any*/),
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "entityIds",
        "variableName": "excludeEntityIds"
      }
    ],
    "kind": "ObjectValue",
    "name": "exclude"
  },
  {
    "fields": [
      (v3/*: any*/)
    ],
    "kind": "ObjectValue",
    "name": "filter"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": {
      "direction": "DESC",
      "field": "PUBLISHED_DATE"
    }
  }
],
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v10 = [
  (v8/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v12 = [
  (v11/*: any*/)
],
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v5/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "UrlRedirect",
  "kind": "LinkedField",
  "name": "urlRedirect",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "toUrl",
      "storageKey": null
    },
    (v5/*: any*/)
  ],
  "storageKey": null
},
v17 = [
  (v7/*: any*/),
  (v5/*: any*/)
],
v18 = {
  "alias": null,
  "args": null,
  "concreteType": "Application",
  "kind": "LinkedField",
  "name": "application",
  "plural": false,
  "selections": (v17/*: any*/),
  "storageKey": null
},
v19 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Section",
      "kind": "LinkedField",
      "name": "fullSectionPath",
      "plural": true,
      "selections": (v17/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentSection",
      "storageKey": null
    }
  ],
  "type": "Section",
  "abstractKey": null
},
v20 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flattenTypeIds",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveArticle",
      "kind": "LinkedField",
      "name": "liveArticle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        },
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v21 = [
  (v7/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Section",
  "abstractKey": null
},
v23 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "VideoSection",
  "abstractKey": null
},
v24 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PaywallType",
      "kind": "LinkedField",
      "name": "paywallTypes",
      "plural": true,
      "selections": [
        (v15/*: any*/),
        (v5/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
},
v25 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "text",
    "storageKey": null
  }
],
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "SectionSegmentV2",
  "kind": "LinkedField",
  "name": "sectionsV2",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "value",
      "plural": true,
      "selections": [
        (v22/*: any*/),
        (v23/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "hooksFeedViewAuthorPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "count",
                "variableName": "count"
              },
              {
                "kind": "Variable",
                "name": "excludeEntityIds",
                "variableName": "excludeEntityIds"
              }
            ],
            "kind": "FragmentSpread",
            "name": "hooksFeedViewAuthorFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "hooksFeedViewAuthorPaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v5/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v6/*: any*/),
                "concreteType": "ContentConnection",
                "kind": "LinkedField",
                "name": "contents",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v4/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isContent"
                          },
                          (v7/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "createdDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "updatedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "publishedDate",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "readingTime",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "headline",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Image",
                            "kind": "LinkedField",
                            "name": "images",
                            "plural": true,
                            "selections": [
                              (v8/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "title",
                                "storageKey": null
                              },
                              (v9/*: any*/),
                              {
                                "alias": "size640x360",
                                "args": [
                                  {
                                    "kind": "Literal",
                                    "name": "filter",
                                    "value": {
                                      "style": "wide_landscape_640_360"
                                    }
                                  }
                                ],
                                "concreteType": "ImageStyle",
                                "kind": "LinkedField",
                                "name": "style",
                                "plural": false,
                                "selections": (v10/*: any*/),
                                "storageKey": "style(filter:{\"style\":\"wide_landscape_640_360\"})"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "socialHeadline",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "flag",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "SectionSegmentV2",
                            "kind": "LinkedField",
                            "name": "sectionsV2",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "value",
                                "plural": true,
                                "selections": [
                                  (v4/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v12/*: any*/),
                                    "type": "Section",
                                    "abstractKey": null
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v12/*: any*/),
                                    "type": "VideoSection",
                                    "abstractKey": null
                                  },
                                  (v13/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Topic",
                            "kind": "LinkedField",
                            "name": "topics",
                            "plural": true,
                            "selections": [
                              (v7/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Sponsor",
                                "kind": "LinkedField",
                                "name": "sponsor",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v9/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Image",
                                    "kind": "LinkedField",
                                    "name": "images",
                                    "plural": true,
                                    "selections": (v10/*: any*/),
                                    "storageKey": null
                                  },
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v5/*: any*/),
                              (v14/*: any*/),
                              (v11/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "shortName",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v18/*: any*/),
                                  (v19/*: any*/),
                                  (v20/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SectionSegmentV2",
                                        "kind": "LinkedField",
                                        "name": "sectionsV2",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": null,
                                            "kind": "LinkedField",
                                            "name": "value",
                                            "plural": true,
                                            "selections": [
                                              (v4/*: any*/),
                                              (v22/*: any*/),
                                              (v13/*: any*/),
                                              (v23/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v24/*: any*/)
                                    ],
                                    "type": "Content",
                                    "abstractKey": "__isContent"
                                  }
                                ],
                                "type": "BaseWithApplicationAndUrlAlias",
                                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "FormattedValue",
                            "kind": "LinkedField",
                            "name": "summary",
                            "plural": false,
                            "selections": (v25/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v15/*: any*/),
                              (v14/*: any*/),
                              (v16/*: any*/),
                              (v18/*: any*/),
                              (v19/*: any*/),
                              (v20/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v26/*: any*/),
                                  (v24/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "BaseWithApplicationAndUrlAlias",
                            "abstractKey": "__isBaseWithApplicationAndUrlAlias"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "PaywallType",
                                "kind": "LinkedField",
                                "name": "paywallTypes",
                                "plural": true,
                                "selections": [
                                  (v11/*: any*/),
                                  (v5/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "commentCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "FormattedValue",
                                "kind": "LinkedField",
                                "name": "multimediaEmbed",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "json",
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ArticleTypeSegment",
                                "kind": "LinkedField",
                                "name": "types",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ArticleType",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": true,
                                    "selections": [
                                      (v7/*: any*/),
                                      (v5/*: any*/),
                                      (v11/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "FormattedValue",
                                        "kind": "LinkedField",
                                        "name": "description",
                                        "plural": false,
                                        "selections": (v25/*: any*/),
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasVideoContent",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Author",
                                "kind": "LinkedField",
                                "name": "authors",
                                "plural": true,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "types",
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "sponsorType",
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v26/*: any*/)
                                ],
                                "type": "Content",
                                "abstractKey": "__isContent"
                              }
                            ],
                            "type": "Article",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v6/*: any*/),
                "filters": [
                  "filter",
                  "exclude",
                  "orderBy"
                ],
                "handle": "connection",
                "key": "hooksFeedViewAuthor__author_contents",
                "kind": "LinkedHandle",
                "name": "contents"
              }
            ],
            "type": "Author",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "11106209babc80cc186f9836398ed2d0",
    "id": null,
    "metadata": {},
    "name": "hooksFeedViewAuthorPaginationQuery",
    "operationKind": "query",
    "text": "query hooksFeedViewAuthorPaginationQuery(\n  $after: String\n  $applicationIds: [String] = []\n  $count: Int = 20\n  $excludeEntityIds: [String] = []\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...hooksFeedViewAuthorFragment_4yWlTm\n    id\n  }\n}\n\nfragment articleCommentArticle on Article {\n  ...entityLink\n  commentCount\n  entityId\n}\n\nfragment contentActionBarContent on Content {\n  __isContent: __typename\n  entityId\n  createdDate\n  updatedDate\n  publishedDate\n  readingTime\n  ...articleCommentArticle\n  ...helpersIsArticleVideoAsHeroArticle\n  ...helpersGetContentTypeNameContent\n  ... on Article {\n    hasVideoContent\n  }\n}\n\nfragment contentCoverImageContent_5M5Ip on Content {\n  __isContent: __typename\n  headline\n  images {\n    url\n    title\n    type\n    size640x360: style(filter: {style: \"wide_landscape_640_360\"}) {\n      url\n    }\n  }\n}\n\nfragment contentHeadlineContent on Content {\n  __isContent: __typename\n  headline\n  socialHeadline\n  ...contentHeadlineTagContent\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentHeadlineTagContent on Content {\n  __isContent: __typename\n  ...hooksContentHeadlineTagContent\n}\n\nfragment contentSponsorTagContent on Content {\n  __isContent: __typename\n  ...helpersUseContentSponsorContent\n}\n\nfragment contentSummaryContent on Content {\n  __isContent: __typename\n  __typename\n  summary {\n    text\n  }\n}\n\nfragment contentTopicLinkContent on Content {\n  __isContent: __typename\n  topics {\n    urlAlias\n    ...entityLink\n    ...topicLinkTopic\n    id\n  }\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment feedViewArticleContent on Content {\n  __isContent: __typename\n  ...entityLink\n  ...hooksUseMyDailyFiveContent\n  ...hooksContentItemProvidersContent_SY16K\n  entityId\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsMainTopicContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersGetArticleTypeNameArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersGetContentTypeNameContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    ...helpersGetArticleTypeNameArticle\n  }\n}\n\nfragment helpersIsArticleVideoAsHeroArticle on Article {\n  multimediaEmbed {\n    json\n  }\n}\n\nfragment helpersSanitizeArticleTypeEntityIdsArticle on Article {\n  types {\n    value {\n      entityId\n      id\n    }\n  }\n}\n\nfragment helpersSanitizeAuthorTypesArticle on Article {\n  authors {\n    types\n    id\n  }\n}\n\nfragment helpersSanitizedAuthorEntityIdsArticle on Article {\n  authors {\n    entityId\n    id\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersUseContentSponsorContent on Content {\n  __isContent: __typename\n  topics {\n    entityId\n    sponsor {\n      ...sponsorTagSponsor\n      name\n      type\n      id\n    }\n    id\n  }\n  ... on Article {\n    sponsorType\n  }\n  ...helpersCheckIsMainTopicContent\n}\n\nfragment hooksContentHeadlineTagContent on Content {\n  __isContent: __typename\n  __typename\n  ... on Article {\n    types {\n      value {\n        name\n        entityId\n        description {\n          text\n        }\n        id\n      }\n    }\n    ...helpersCheckIsStyleArticle\n  }\n  flag\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        name\n      }\n      ... on VideoSection {\n        name\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n  ...hooksContentHelperContent\n}\n\nfragment hooksContentHelperContent on Content {\n  __isContent: __typename\n  ...helpersSanitizeArticleTypeEntityIdsArticle\n  ...helpersSanitizeAuthorTypesArticle\n  ...helpersSanitizedAuthorEntityIdsArticle\n  flag\n}\n\nfragment hooksContentItemProvidersContent_SY16K on Content {\n  __isContent: __typename\n  ...contentActionBarContent\n  ...contentCoverImageContent_5M5Ip\n  ...contentHeadlineContent\n  ...contentSummaryContent\n  ...contentTopicLinkContent\n  ...contentSponsorTagContent\n  ... on Video {\n    __typename\n  }\n  ... on Gallery {\n    __typename\n  }\n}\n\nfragment hooksFeedViewAuthorFragment_4yWlTm on Author {\n  contents(after: $after, first: $count, filter: {applicationIds: $applicationIds}, exclude: {entityIds: $excludeEntityIds}, orderBy: {field: PUBLISHED_DATE, direction: DESC}) {\n    edges {\n      node {\n        __typename\n        __isContent: __typename\n        ...feedViewArticleContent\n        id\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment hooksUseMyDailyFiveContent on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      name\n      id\n    }\n  }\n}\n\nfragment sponsorTagSponsor on Sponsor {\n  name\n  type\n  images {\n    url\n  }\n}\n\nfragment topicLinkTopic on Topic {\n  ...entityLink\n  name\n  shortName\n}\n"
  }
};
})();

(node as any).hash = "f7ed0c6e3050a38a502d8c1fed5d1ac9";

export default node;
